import { useMemo } from 'react';
import PhotoAPI from '@/services/photo-api';
import { type INoteItemUomImage } from '@/types/INote';
import styles from './index.module.scss';

export default function UomImage ({
  author,
  imageId,
  title,
}: INoteItemUomImage) {
  const shallShowCaption = useMemo(() => Boolean(title) || Boolean(author), [title, author]);
  const imageCaption = useMemo(() => [title, author].filter(Boolean).join(' '), [title, author]);

  const src = useMemo(() => PhotoAPI.photoFromXX(imageId.toString(), 'IH', 'jpg'), [imageId]);
  const srcSet = useMemo(() => src ? [src, `${src.replace('IH,', 'IHR,')} 2x`].join(', ') : '', [src]);

  return (
    <figure className={styles['uom-image']}>
      <picture className={styles['uom-image__picture']}>
        <img alt={title || ''} className={styles['uom-image__img']} src={src} srcSet={srcSet} />
      </picture>
      {shallShowCaption ? <figcaption className={styles['uom-image__caption']}>{imageCaption}</figcaption> : null}
    </figure>
  );
}
